<template>

    <div>
        <fieldset>
            <div class="form-group">
                <div class="col-sm-12 col-md-4">
                    <fg-input type="text" label="Name*" name="projectName" v-validate="modelValidations.projectName"
                        :error="getError('projectName')" v-model="model.projectName">
                    </fg-input>
                </div>
            </div>
        </fieldset>
        <br />
        <fieldset>
            <div class="form-group">
                <label class="col-sm-12 control-label">Description</label>
                <div class="col-sm-8">
                    <textarea v-model="model.projectDescription" required class="form-control" rows="3"></textarea>
                </div>
            </div>
        </fieldset>
        <br>
        <fieldset>
            <div class="form-group">
                <label class="col-sm-12 control-label">Banner Message (Optional)</label>
                <div class="col-sm-8">
                    <textarea
                        placeholder="This message will appear on the top of the project overview screen. You can use it for reminders or notes to yourself or other users."
                        v-model="model.projectBannerMessage" required class="form-control" rows="3"></textarea>
                </div>
            </div>
        </fieldset>
        <br />
        <div class="col-sm-12">
            <div class="row">
                <label class="col-sm-12 control-label">Visibility</label>
                <div class="col-sm-3">
                    <p-radio v-model="model.projectAssociate" label="1" @change="onVisibilityChange">Private</p-radio>
                    <p-radio v-model="model.projectAssociate" label="2">Entire Organisation</p-radio>
                </div>

                <template v-if="model.projectAssociate == '2' && userOrganisations.length == 0">
                    <div class="col-sm-4">
                        <p>
                            You have not yet applied to be an Organisation. Like Teams, Organisations enable
                            collaboration
                            features allowing you to add others as administrators or field users to your projects.<a
                                href="/platform/user/organisation"> Apply Now</a>
                        </p>
                    </div>
                </template>
                <template v-else>
                    <div class="col-sm-5">
                        <p>{{ projectAssociateInfo }}</p>
                    </div>
                </template>
            </div>
        </div>

        <br />

        <fieldset>
            <div class="form-group">
                <label class="col-sm-12 control-label">Ownership</label>

                <div class="col-sm-12">
                    <el-checkbox-group v-model="model.selectedCategories">
                        <el-checkbox v-for="ownership in ownerships" :key="ownership" :label="ownership">{{ ownership
                            }}</el-checkbox>
                    </el-checkbox-group>
                </div>

            </div>
        </fieldset>
        <br>

        <template v-if="model.projectAssociate == '2' && userOrganisations.length > 0">
            <fieldset>
                <div class="form-group">
                    <label class="col-sm-12 control-label">Species</label>
                    <div class="col-sm-12">
                        <el-checkbox-group v-model="model.selectedAnimals">
                            <el-checkbox v-for="(animal, key) in orgAnimals" :label="animal.species_name"
                                :key="'defaultAnimal' + key">
                                {{ animal.species_name }}
                            </el-checkbox>
                        </el-checkbox-group>
                    </div>
                </div>
            </fieldset>
            <div ref="addNewAnimalDialogBox" class="col-sm-4">
                <template>
                    <a @click="showManageItemsModal('species')" style="color: #51cbce;">Manage</a>
                </template>
            </div>
        </template>

        <template v-else>
            <fieldset>
                <div class="form-group">
                    <label class="col-sm-12 control-label">Species</label>
                    <div class="col-sm-12">
                        <el-checkbox-group v-model="model.selectedAnimals">
                            <el-checkbox label="1">DOG</el-checkbox>
                        </el-checkbox-group>
                    </div>
                </div>
            </fieldset>
        </template>

        <br />

        <fieldset>
            <div class="form-group">
                <label class="col-sm-12 control-label">Vaccine/Drug</label>
                <div class="col-sm-10">
                    <el-checkbox-group v-model="model.vaccinationDrug">
                        <el-checkbox v-for="(vaccination, key) in vaccinationDrug" :label="vaccination.id"
                            :key="'defaultVaccine' + key">
                            {{ vaccination.vaccination_drug }}
                        </el-checkbox>
                    </el-checkbox-group>
                </div>
            </div>
        </fieldset>

        <template v-if="model.projectAssociate == '2' && userOrganisations.length > 0">
            <div ref="addDrugVaccineDialogBox" class="col-sm-4">
                <template>
                    <a @click="showManageItemsModal('vaccine')" style="color: #51cbce;">Manage</a>
                </template>
            </div>
        </template>

        <br>

        <fieldset>
            <div class="form-group">
                <label class="col-sm-12 control-label">Treatments</label>
                <div class="col-sm-10">
                    <el-checkbox-group v-model="model.treatments">
                        <el-checkbox v-for="(treatment, key) in treatments" :label="treatment.id"
                            :key="'treatment' + key">
                            {{ treatment.treatment_name }}
                        </el-checkbox>
                    </el-checkbox-group>
                </div>
            </div>
        </fieldset>

        <template v-if="model.projectAssociate == '2' && userOrganisations.length > 0">
            <div ref="addDrugVaccineDialogBox" class="col-sm-4">
                <template>
                    <a @click="showManageItemsModal('treatment')" style="color: #51cbce;">Manage</a>
                </template>
            </div>
        </template>

        <br>

        <fieldset>
            <div class="form-group">
                <label class="col-sm-12 control-label">Deworming</label>
                <div class="col-sm-10">
                    <el-checkbox-group v-model="model.dewormings">
                        <el-checkbox v-for="(deworming, key) in dewormings" :label="deworming.id"
                            :key="'deworming' + key">
                            {{ deworming.deworming_name }}
                        </el-checkbox>
                    </el-checkbox-group>
                </div>
            </div>
        </fieldset>

        <template v-if="model.projectAssociate == '2' && userOrganisations.length > 0">
            <div ref="addDrugVaccineDialogBox" class="col-sm-4">
                <template>
                    <a @click="showManageItemsModal('deworming')" style="color: #51cbce;">Manage</a>
                </template>
            </div>
        </template>


        <br />
        <br />
        <div class="col-lg-12">
            <div class="row">
                <div class="col-lg-12">
                    <label class="control-label">Project Location</label>
                    <div class="card">
                        <div class="card-header">
                            <p class="card-title"><b>(Search for your city/region and then pin it
                                    on the map using your cursor)</b></p>
                        </div>
                        <div class="card-body">
                            <MapBase
                                v-if="mapCenter.lat"
                                :allowPinDrop="true"
                                :enableSearch="true"
                                :zoom="ipBasedZoom || 15"
                                :center="mapCenter"
                                @map-clicked="getGeoLocation"
                                @address-selected="addressSelected"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <p>
                        To load Country, State and Province please select location pin point on Google Maps.
                    </p>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-4">
                    <label class="control-label">Country</label>
                    <br />
                    <fg-input :disabled="fetchingAddress" v-model="model.selectedCountry"
                        :placeholder="selectCountryLabel" />
                </div>
                <div class="col-lg-4">
                    <label class="control-label">State/Province</label>
                    <br />
                    <fg-input :disabled="fetchingAddress" v-model="model.selectedState"
                        :placeholder="selectStateLabel" />
                </div>
                <div class="col-lg-4">
                    <label class="control-label">City/District/Village</label>
                    <br />
                    <fg-input :disabled="fetchingAddress" v-model="model.selectedLocality"
                        :placeholder="selectLocalityLabel" />
                </div>
            </div>
        </div>
        <br />
        <br />
        <label class="col-sm-12 control-label" style="display: none">Project Date Format</label>
        <div class="col-sm-2" style="display: none">
            <el-select class="select-info" size="large" placeholder="Single Select" v-model="model.selectedDateFormat">
                <el-option v-for="dateFormat in model.dateFormats" class="select-danger" :value="dateFormat"
                    :label="dateFormat" :key="dateFormat">
                </el-option>
            </el-select>
        </div>
        <br />
        <label class="col-sm-12 control-label" style="display: none">Project Time Zone</label>
        <div class="col-sm-12 col-md-4" style="display: none">
            <el-select class="select-info" size="large" placeholder="Single Select" v-model="model.selectedTimezone">
                <el-option v-for="timezone in timezones" class="select-danger" :value="timezone.label"
                    :label="timezone.label" :key="timezone.label">
                </el-option>
            </el-select>
        </div>
        <br />
        <div class="col-sm-10" style="display: none">
            <p>Select Project Image ({{ uploadingLabel }})</p>
            <image-upload :target="imageUploadApiUrl" selector="example" :auto-push="true">
            </image-upload>
            <br />
        </div>
        <div class="col-md-12" style="text-align: center !important;">

            <button @click="cancelNewProject('warning-message-and-confirmation')" type="button"
                class="btn btn-round btn-danger">Cancel
            </button>

            <button v-if="onLine" v-bind:disabled="isDisabled || !onLine" v-on:click="validateAndSubmit" type="button"
                class="btn btn-round btn-info">Create HC Project
            </button>

        </div>

        <el-dialog :visible.sync="showItemsModal" :show-close="false" width="40%" class="newProjectItemModal">
            <species-list v-if="itemModalType === 'species'"></species-list>
            <drug-vaccine-list v-if="itemModalType === 'vaccine'"></drug-vaccine-list>
            <manage-treatment-list v-if="itemModalType === 'treatment'"></manage-treatment-list>
            <manage-deworming-list v-if="itemModalType === 'deworming'"></manage-deworming-list>

            <div class="species-footer">
                <button type="button" class="btn btn-default" style="background-color: var(--hw-danger) !important;"
                    @click="showItemsModal = false">
                    Close
                </button>
            </div>
        </el-dialog>
    </div>

</template>

<script>

import { Select, Option, CheckboxGroup, Checkbox, Dialog } from 'element-ui';
import Swal from 'sweetalert2';
import { mapGetters } from 'vuex';
import mixin from '../../../mixins/GlobalMixin';
import ImageUpload from '../../ImageUpload.vue';

import hclogo from '../../../assets/images/hc_logo_small.png';

import timezoneJson from '../../../assets/json/timezones.json'
import DrugVaccineList from "../DrugVaccineList";
import SpeciesList from "../SpeciesList";
import ManageTreatmentList from "../../platform/ManageTreatmentList";
import ManageDewormingList from "../../platform/ManageDewormingList";
import MapBase from '../../map/MapBase.vue';
import ReverseGeocodingService from '../../../services/reverse-geocoding.service';


export default {
    name: 'NewHcProject',
    components: {
        ManageDewormingList,
        ManageTreatmentList,
        SpeciesList,
        DrugVaccineList,
        [Option.name]: Option,
        [Select.name]: Select,
        [CheckboxGroup.name]: CheckboxGroup,
        [Checkbox.name]: Checkbox,
        [Dialog.name]: Dialog,
        'image-upload': ImageUpload,
        MapBase
    },
    mixins: [mixin],
    props: {
        projectId: {
            type: Number,
            default: 0,
        },
        timezones: {
            type: Array,
            default: timezoneJson
        },
        hclogo: {
            type: String,
            default: hclogo,
        },
    },
    data() {
        return {
            showItemsModal: false,
            itemModalType: '',
            imageUploadApiUrl: window.API_BASE_URL + '/UploadToS3/upload/project_image',
            ownerships: [
                "Owned",
                "Owned free roaming",
                "Community",
                "Community free roaming",
                "Wild"
            ],
            vaccinationDrug: [
                {
                    id: 1,
                    vaccination_drug: 'Rabies'
                },
            ],
            orgAnimals: [],
            treatments: [],
            dewormings: [],
            model: {
                selectedVets: [],
                projectName: '',
                projectDescription: '',
                selectedAnimals: [],
                dateFormats: ['DD-MM-YYYY', 'MM-DD-YYYY', 'YYYY-MM-DD'],
                selectedDateFormat: 'DD-MM-YYYY',
                selectedTimezone: 'UTC',
                projectAssociate: '2',
                selectedCategories: [],
                selectedOrganisation: null,
                selectedCountry: null,
                selectedState: null,
                selectedLocality: null,
                selectedLocation: null,
                projectBannerMessage: '',
                vaccinationDrug: [],
                treatments: [],
                dewormings: [],
            },
            modelValidations: {
                projectName: {
                    required: true,
                }
            },
            isDisabled: false,
            uploadURL: '',
            uploadingLabel: 'Optional',
            uploadPending: false,
            fetchingAddress: false,
            selectCountryLabel: 'Select Country',
            selectStateLabel: 'Select State',
            selectLocalityLabel: 'Select Locality',
            selectedMarker: null,
            mapCenter: {},
            ipBasedZoom: null
        }
    },

    methods: {
        addressSelected(event) {
            const latLng = {
                lat: event.y,
                lng: event.x
            }
            this.getGeoLocation(latLng);
        },
        init() {

            let vm = this;

            vm.$store.dispatch('animal/getAnimals');

            vm.$store.dispatch('user/getUserOrganisations');

            window.Bus.$on('example-did-upload', (error, data, response) => {
                if (error) {
                    window.toastr.error(error);
                } else {
                    vm.uploadURL = response.src;
                    vm.uploadingLabel = "Uploaded";
                    vm.uploadPending = false;
                }
            });

            window.Bus.$on('example-is-saving', () => {
                vm.uploadPending = true;
                vm.uploadingLabel = "Uploading Image...";
            });

            vm.initMap();

        },
        initMap() {
            let vm = this;

            if (vm.projectId == 0) {
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(function (position) {
                        let pos = {
                            lat: position.coords.latitude,
                            lng: position.coords.longitude
                        };

                        vm.mapCenter = pos;
                    }, function () {
                        handleLocationError(true);
                    });
                } else {
                    handleLocationError(false);
                }
            }


            function handleLocationError(browserHasGeolocation) {
                if (browserHasGeolocation) {
                    console.log('Error: The Geolocation service failed.');
                } else {
                    console.log('Error: Your browser doesn\'t support geolocation.');
                }
                vm.getLocationFromIP();
            }

        },
        async getLocationFromIP() {
            try {
                const response = await fetch('https://ip-api.com/json/?fields=lat,lon,country,regionName');
                const data = await response.json();
                if (data && data.lat && data.lon) {
                    this.mapCenter = { lat: data.lat, lng: data.lon };
                    this.ipBasedZoom = 6;
                } else {
                    this.mapCenter = { lat: 20, lng: 0 };
                    this.ipBasedZoom = 2;
                }
            } catch (error) {
                console.log('IP geolocation failed:', error);
                this.mapCenter = { lat: 20, lng: 0 };
                this.ipBasedZoom = 2;
            }
        },
        async getGeoLocation (latLng) {
            let vm = this;

            vm.selectCountryLabel = 'Loading..';
            vm.selectStateLabel = 'Loading...';
            vm.selectLocalityLabel = 'Loading...';

            vm.model.selectedLocation = `${latLng.lat},${latLng.lng}`;
            vm.model.selectedCountry = null;
            vm.model.selectedState = null;
            vm.model.selectedLocality = null;

            vm.fetchingAddress = true;

            try {
                const latlng = vm.model.selectedLocation.split(',');
                const address = await ReverseGeocodingService.getAddress(latlng);

                vm.model.selectedCountry = address.country;
                vm.model.selectedState = address.state;
                vm.model.selectedLocality = address.locality;

            } catch(error){
                console.log(error);
            } finally {
                vm.fetchingAddress = false;
                vm.selectCountryLabel = 'Country';
                vm.selectStateLabel = 'State';
                vm.selectLocalityLabel = 'Locality';
            }

        },
        validateAndSubmit: function (event) {

            if (this.model.selectedCategories.length == 0) {
                this.showAlert('Error', "You must select at least one ownership option", false);
                return;
            }

            if (!this.onLine) {
                this.showAlert('Offline', "You are offline please check your network connection and try again.", false);
                return;
            }

            if (this.uploadPending) {
                this.showAlert('Error', "Please wait image is being uploaded", false);
                return;
            }
            if (this.model.projectName == '') {
                this.showAlert('Error', "The projectName field is required", false);
                return;
            }
            if (this.model.selectedLocation == null) {
                this.showAlert('Error', "Please select location pin point on map for this project.", false);
                return;
            }

            if (!this.model.selectedCountry) {
                this.showAlert('Error', "Country field is required.", false);
                return;
            }

            if (!this.model.selectedState) {
                this.showAlert('Error', "State field is required.", false);
                return;
            }

            if (!this.model.selectedLocality) {
                this.showAlert('Error', "Locality field is required.", false);
                return;
            }
            this.isDisabled = true;

            this.$validator.validateAll().then((result) => {
                let vm = this;
                if (vm.uploadURL == '') {
                    vm.uploadURL = '/images/hc_logo_med.png';
                }
                if (result) {
                    if (vm.model.selectedAnimals.length === 0) {
                        vm.isDisabled = false;
                        vm.showAlert('Error', "Please select one or more animals for this project.", false);
                        return;
                    } else {
                        if (vm.projectId == 0) {
                            const loading = vm.$loading({
                                lock: true,
                                text: 'Please wait creating project...',
                                spinner: 'el-icon-loading',
                                background: 'rgba(0, 0, 0, 0.7)'
                            });
                            vm.$store.dispatch('user/createProject', {
                                name: vm.model.projectName,
                                description: vm.model.projectDescription,
                                banner_message: vm.model.projectBannerMessage,
                                timezone: vm.model.selectedTimezone,
                                project_animals: vm.model.selectedAnimals,
                                date_format: vm.model.selectedDateFormat,
                                type: 'HC',
                                image_url: vm.uploadURL,
                                project_location_lat_lng: vm.model.selectedLocation,
                                country: vm.model.selectedCountry,
                                google_admin_area_level1: vm.model.selectedState,
                                google_locality: vm.model.selectedLocality,
                                organisation_id: vm.model.selectedOrganisation,
                                vaccination_drug_ids: vm.model.vaccinationDrug,
                                treatment_ids: vm.model.treatments,
                                deworming_ids: vm.model.dewormings,
                                category: vm.model.selectedCategories.toString(),
                                vet_ids: vm.model.selectedVets,
                            }).then((successful) => {
                                if (successful === true) {
                                    loading.close();
                                    this.$emit('project-created');
                                    this.$store.dispatch('user/getUser').then((response) => {
                                        this.$root.$emit('userDataSet');
                                        vm.$router.replace("/platform/projects");
                                    });
                                } else {
                                    if (successful.length == 0) {
                                        vm.showAlert('Error', ' Sorry, You cannot create this project because a project with same name already exist.', false);
                                    } else {
                                        vm.showAlert('Error', successful.toString(), false);
                                    }
                                }
                            });
                        }
                    }
                }
                vm.isDisabled = false;
                return false;
            }).catch(() => {
                this.isDisabled = false;
                return false
            });
        },
        getError: function getError(fieldName) {
            return this.errors.first(fieldName);
        },
        cancelNewProject(type) {
            let vm = this;
            vm.$router.replace("/platform/projects");
        },
        isCharAllow: function (evt) {
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode >= 65 && charCode <= 90) || (charCode >= 97 && charCode <= 122)) {
                return true;
            } else {
                evt.preventDefault();
                this.showAlert('Error', "Only alphabets are allowed", false);
            }
        },

        getOrgHealthAndCareData() {
            this.getOrgAnimals();
            this.getOrgVaccinations();
            this.getOrgTreatments();
            this.getOrgDewormings();
        },

        getOrgAnimals() {
            let vm = this;
            vm.orgAnimals = [];
            if (vm.model.selectedOrganisation != null) {
                const orgSpecies = vm.$store.getters.getOrgSpecies;
                for (let i = 0; i < orgSpecies.length; i++) {
                    let vaccine = {
                        id: orgSpecies[i].id,
                        species_name: orgSpecies[i].species_name,
                    };
                    vm.orgAnimals.push(vaccine);
                }
            }
        },

        getOrgVaccinations() {
            const vm = this;
            vm.vaccinationDrug = [];
            if (vm.model.selectedOrganisation != null) {
                const orgVaccinationDrugs = vm.$store.getters.getVaccinationDrugs;
                for (let i = 0; i < orgVaccinationDrugs.length; i++) {
                    let vaccine = {
                        id: orgVaccinationDrugs[i].id,
                        vaccination_drug: orgVaccinationDrugs[i].vaccination_drug_name,
                    };
                    vm.vaccinationDrug.push(vaccine);
                }
            }
        },

        getOrgTreatments() {
            const vm = this;
            vm.treatments = [];
            if (vm.model.selectedOrganisation != null) {
                const treatments = vm.$store.getters.getTreatments;
                for (let i = 0; i < treatments.length; i++) {
                    vm.treatments.push({
                        id: treatments[i].id,
                        treatment_name: treatments[i].treatment_name,
                    });
                }
            }
        },

        getOrgDewormings() {
            const vm = this;
            vm.dewormings = [];
            if (vm.model.selectedOrganisation != null) {
                const orgDewormings = vm.$store.getters.getDeworming;
                for (let i = 0; i < orgDewormings.length; i++) {
                    vm.dewormings.push({
                        id: orgDewormings[i].id,
                        deworming_name: orgDewormings[i].deworming_name,
                    });
                }
            }
        },

        onVisibilityChange() {
            const vm = this;
            if (vm.model.projectAssociate === '1') {
                new Swal({
                    icon: 'info',
                    title: 'Are you sure you want to change visibility to Private?',
                    text: `Private projects are only visible to you, you can not invite others to the project. Mainly intended for testing/setup purposes.`,
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonClass: 'btn btn-success btn-fill',
                    cancelButtonClass: 'btn btn-danger btn-fill',
                    confirmButtonText: 'Yes',
                    buttonsStyling: false,
                }).then(function (result) {
                    if (!result.value) {
                        vm.model.projectAssociate = '2';
                    }
                });
            }
        },

        showManageItemsModal(modalType) {
            this.showItemsModal = true;
            this.itemModalType = modalType;
        }
    },

    computed: {
        ...mapGetters('user', ['userOrganisations']),
        ...mapGetters('user', ['getVetsInOrganisation']),
        projectAssociateInfo: function () {
            let vm = this;
            if (vm.model.projectAssociate == '1') {
                vm.model.selectedOrganisation = null;
                vm.vaccinationDrug = [
                    {
                        id: 1,
                        vaccination_drug: 'Rabies'
                    },
                ];
                vm.model.vaccinationDrug = [];
                return 'Private projects are only visible to you, you can not invite others to the project.  Mainly intended for testing/setup purposes.  You can later change visibility to Organisation if you are affiliated with one.';
            } else {
                vm.vaccinationDrug = [];
                vm.model.vaccinationDrug = [];
                if (vm.model.projectAssociate == '2' && vm.userOrganisations.length > 0) {
                    vm.model.selectedOrganisation = vm.userOrganisations[0].organisation.id

                    vm.getOrgHealthAndCareData()
                    return vm.userOrganisations[0].organisation.name + ' organisation will be notified for the new project and will have full rights to transfer and delete the project.';
                } else {
                    vm.model.selectedOrganisation = null
                    return ''
                }
            }
        },
    },

    mounted() {
        this.init();
    }
}

</script>
<style scoped>
a {
    color: #51cbce;
}

a:hover {
    cursor: pointer;
    text-decoration: underline;
    color: #51cbce;
}

.el-checkbox {
    margin: 0;
    padding: 0px 20px 5px 0px;
}

.el-select {
    width: inherit;
}
.species-footer {
    text-align: right;
}
</style>
